// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1GMV_","legacyBtn":"MutateMid_legacyBtn__HtBE1"};